import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environment/environment';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  RefreshTokenRequest,
  RefreshTokenResponse,
} from '../model/notification.model';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private baseUrl = environment.apiUrl;
  private refreshTokenAsyncUrl = `${this.baseUrl}/api/1.0/auth/refreshTokenAsync`;

  constructor(public jwtHelper: JwtHelperService, private http: HttpClient) {}

  getUserCodeToken(): string {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.UserCode ? decodedToken.UserCode.toString() : '';
    }
    return '';
  }

  getUserInfoIdToken(): number {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.UserInfoId ? +decodedToken.UserInfoId : 0;
    }
    return 0;
  }

  getDocCode(): string {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.DocCode ? decodedToken.DocCode : '';
    }
    return '';
  }

  getTaxLabelToken(): string {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.TaxLabel ? decodedToken.TaxLabel : '';
    }
    return '';
  }

  getTaxPercentageToken(): string {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.TaxPercentage ? decodedToken.TaxPercentage : '';
    }
    return '';
  }

  getCurrencyInfoIdToken(): number {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.CurrencyInfoId ? +decodedToken.CurrencyInfoId : 0;
    }
    return 0;
  }

  getCurrencySymbolToken(): string {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.CurrencySymbol ? decodedToken.CurrencySymbol : '';
    }
    return '';
  }

  getUserNameToken(): string {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.UserName ? decodedToken.UserName : '';
    }
    return '';
  }

  getMobileNumToken(): string {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken.UserName ? decodedToken.MobileNo : '';
    }

    return '';
  }

  
  refreshToken(): Observable<string> {
    const payload: RefreshTokenRequest = {
      mobileNoOrEmailId: localStorage.getItem('MobileNo') || '',
      token: localStorage.getItem('token') || '',
      refreshTokenKey: localStorage.getItem('refreshKey') || '',
    };

    return this.http
      .post<RefreshTokenResponse>(this.refreshTokenAsyncUrl, payload)
      .pipe(
        map((response) => {
          if (response.status === 1 && response.token) {
            localStorage.setItem('token', response.token);
            localStorage.setItem('refreshKey', response.refreshTokenKey);
            return response.token;
          } else {
            throw new Error(response.statusMessage || 'Token refresh failed');
          }
        }),
        catchError((error) => throwError(() => error))
      );
  }
}
